import styles from "./Arrow.module.scss";
import isEmpty from "lodash/isEmpty";

const ArrowLeft = (props) => {
  return (
    <button className={styles.prev} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
      >
        <path
          d="M16.7503 21.0833L9.16699 13.5L16.7503 5.91663"
          stroke="#B7BCCD"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

const ArrowRight = (props) => {
  return (
    <button className={styles.next} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
      >
        <path
          d="M10.2497 21.0833L17.833 13.5L10.2497 5.91663"
          stroke="#B7BCCD"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

const Arrows = ({slider}) => {
  if (isEmpty(slider?.current)) {
    return "";
  }

  return (
    <div className={styles.arrows}>
      <ArrowLeft
        onClick={(e) => {
          e.stopPropagation();
          slider.current?.prev();
        }}
      />

      <ArrowRight
        onClick={(e) => {
          e.stopPropagation()
          slider.current?.next()
        }}
      />
    </div>
  );
};

export default Arrows;
